import { useState } from "react"
import Card from "@/components/card"
import Button from "@/components/button"
import { faDownload } from "@fortawesome/free-solid-svg-icons"
import { useAppDispatch } from "@/core/root-reducer"
import { Document } from "../model/document.types"
import { getDocumentYear } from "../utils/document-year.utils"
import { formatDocumentDate } from "../utils/document-file.utils"
import { exportPapripactToPdf } from "../utils/exportDocumentToPdf"
import { toast } from "react-toastify"

export default function PapripactDocument({ document }: { document: Document }) {
  const dispatch = useAppDispatch()
  const [isDownloading, setIsDownloading] = useState(false)

  async function download() {
    if (isDownloading) return
    setIsDownloading(true)
    try {
      await exportPapripactToPdf(dispatch, document)
    } catch {
      toast("Le PDF n'a pas pu être généré.", { type: "error" })
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <main className="min-h-screen bg-[#f6f6f6] px-[30px] py-[30px]">
      <div className="mx-auto max-w-[1000px]">
        <div className="mb-[24px] flex flex-wrap items-center justify-between gap-[20px]">
          <h1 className="m-0 text-lg">PAPRIPACT {getDocumentYear(document)}</h1>
          <Button icon={faDownload} onClick={download} isLoading={isDownloading}>
            Télécharger en PDF
          </Button>
        </div>
        <Card>
          <h2 className="m-0 text-lg font-normal">
            Programme annuel de prévention des risques professionnels et d’amélioration des conditions de travail
          </h2>
          <p className="mt-[20px] text-base">{document.content?.establishment?.name}</p>
          <p className="grey-t text-base">
            Généré le {formatDocumentDate(document.content?.generatedAt ?? document.date)}
          </p>
          <div className="mt-[24px] pt-[24px] text-base" style={{ borderTop: "1px solid #eeeeee" }}>
            Document provisoire — le contenu du programme n’est pas encore généré.
          </div>
        </Card>
      </div>
    </main>
  )
}
